import { render, staticRenderFns } from "./Contact_us.vue?vue&type=template&id=ad864e54&scoped=true&"
import script from "./Contact_us.vue?vue&type=script&lang=js&"
export * from "./Contact_us.vue?vue&type=script&lang=js&"
import style0 from "./Contact_us.vue?vue&type=style&index=0&id=ad864e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad864e54",
  null
  
)

export default component.exports